/**
 * Veri sorumlusu / hizmet sağlayıcı kimliği. `[●]` alanları şirket tarafından
 * doldurulacak — yayına almadan önce hepsi gerçek değerle değiştirilmelidir.
 */
export const SIRKET_BILGILERI = {
  unvan: "TUPPA BİLİŞİM TEKNOLOJİLERİ A.Ş.",
  kisaAd: "TUPPA",
  platformAdi: "Muhasebe AI",
  alanAdi: "www.muhasebeal.com.tr",
  adres: "[●]",
  mersisNo: "[●]",
  vergiDairesiNo: "[●]",
  eposta: "info@tuppa.com.tr",
  kepAdresi: "[●]",
  telefon: "0530 633 46 66",
  yetkiliMahkeme: "Ankara",
} as const
